import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleFilterBar = ({ selectedRole, onRoleChange, agentMetrics }) => {
  const roles = [
    { value: 'all', label: 'All Agents', icon: 'Users' },
    { value: 'coordinator', label: 'Coordinator', icon: 'Briefcase' },
    { value: 'validator', label: 'Validator', icon: 'CheckCircle' },
    { value: 'analyst', label: 'Analyst', icon: 'BarChart3' },
    { value: 'auditor', label: 'Auditor', icon: 'Shield' },
    { value: 'specialist', label: 'Specialist', icon: 'Star' }
  ];

  const getRoleCount = (role) => {
    if (role === 'all') return agentMetrics?.length || 0;
    return agentMetrics?.filter(agent => agent?.role === role)?.length || 0;
  };

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="Filter" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-semibold text-foreground">Filter by Agent Role</h3>
      </div>
      <div className="flex flex-wrap gap-3">
        {roles?.map((role) => {
          const count = getRoleCount(role?.value);
          const isSelected = selectedRole === role?.value;

          return (
            <button
              key={role?.value}
              onClick={() => onRoleChange(role?.value)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-all ${
                isSelected
                  ? 'bg-primary text-primary-foreground border-primary shadow-md'
                  : 'bg-background border-border hover:border-primary hover:bg-accent/5'
              }`}
            >
              <Icon 
                name={role?.icon} 
                size={16} 
                color={isSelected ? 'currentColor' : 'var(--color-muted-foreground)'} 
              />
              <span className={`text-sm font-medium ${
                isSelected ? 'text-primary-foreground' : 'text-foreground'
              }`}>
                {role?.label}
              </span>
              <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                isSelected
                  ? 'bg-primary-foreground/20 text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}>
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default RoleFilterBar;